import { render, staticRenderFns } from "./DraftEditorDraggableWidgets.vue?vue&type=template&id=52dcb550&scoped=true&"
import script from "./DraftEditorDraggableWidgets.vue?vue&type=script&lang=js&"
export * from "./DraftEditorDraggableWidgets.vue?vue&type=script&lang=js&"
import style0 from "./DraftEditorDraggableWidgets.vue?vue&type=style&index=0&id=52dcb550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dcb550",
  null
  
)

export default component.exports